import { RentalObject } from './rental-object';
import { FormOfLease, RentalObjectCategory } from './const/enums';
import { Address } from '../../common/model/address';
import { DwellingInspection } from '../../dwelling-inspection/model/dwelling-inspection';
import { Room } from './room';
import { RentalObjectConsumptionMeter } from '../../consumption/model/rentalobject-consumption-meter';
import { BrfSpecifics } from './brf-specifics';
import { LinkedCustomProperty } from './linked-custom-property';
import { ModelBase } from '../../core/model/model-base';
import { PostTargetModel } from '../service/base/post-target-loader.interface';
import { CompanyCustomProperty } from './company-custom-property';

export class Dwelling extends RentalObject {
  constructor() {
    super();
    this.category = RentalObjectCategory.Dwelling;
    this.elevator = false;
    this.indvidualMeterElectricity = false;
    this.indvidualMeterWater = false;
    this.indvidualMeterColdWater = false;
    this.indvidualMeterHeating = false;
    this.furnished = false;
    this.dwellingInspections = [];
    this.rentalObjectCustomProperties = [];
    this.companyCustomProperties = [];
  }

  apartmentNumber: string;
  atticStorageNumber: string;
  basementStorageNumber: string;
  otherStorageNumber: string;
  parkingIncludedInRent: string;
  elevator: boolean;
  floor: number;

  indvidualMeterElectricity: boolean;
  indvidualMeterColdWater: boolean;
  indvidualMeterWater: boolean;
  indvidualMeterHeating: boolean;
  imdMeterColdWater: RentalObjectConsumptionMeter;
  imdMeterElectricity: RentalObjectConsumptionMeter;
  imdMeterHotWater: RentalObjectConsumptionMeter;
  imdMeterHeating: RentalObjectConsumptionMeter;
  brfSpecifics: BrfSpecifics;
  rentalObjectCustomProperties: LinkedCustomProperty[];
  companyCustomProperties: CompanyCustomProperty[];
  condominiumShare: number;
  economicalPlanNumber: string;

  allowedFormsOfLease: FormOfLease[];
  numberOfRooms: number;
  dwellingInspections: DwellingInspection[];
  entranceId: string;
  rooms: Room[];
  furnished: boolean;
  buildingName: string;
  changedAt: Date;

  toString(culture?: string): string {
    if (this.address) {
      let stringView: string = this.rentalId;
      if (this.address instanceof Address) {
        stringView += `, ${this.address.street}`;
      } else {
        stringView += `, ${this.address}`;
      }
      return stringView;
    }
    return this.rentalId;
  }
}

export class DwellingPostTarget extends ModelBase implements PostTargetModel {
  constructor(dataContext?: DwellingPostTarget) {
    super();
    if (dataContext) {
      this.id = dataContext.id || '';
      this.companyNumberName = dataContext.companyNumberName || '';
      this.propertyNumberName = dataContext.propertyNumberName || '';
      this.buildingNumberName = dataContext.buildingNumberName || '';
      this.dwellingNumberName = dataContext.dwellingNumberName || '';
    }
  }

  companyNumberName: string;
  propertyNumberName: string;
  buildingNumberName: string;
  dwellingNumberName: string;

  postTargetDescription() {
    return {
      key: 'POST.POST_TARGET_DESCRIPTION.DWELLING',
      params: {
        companyName: this.companyNumberName,
        propertyName: this.propertyNumberName,
        buildingName: this.buildingNumberName,
        dwellingName: this.dwellingNumberName,
      },
    };
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
      case 'list':
        return this.dwellingNumberName;
    }
  }

  toString(culture?: string): string {
    return this.dwellingNumberName;
  }
}
